import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import ReactDOM from "react-dom";
import RenderToIndex from "./RenderToIndex";
import "./index.css";

import { Provider } from "react-redux";
import { MyContextProvider } from '../src/Components/context/ContextProvider';
import { AUTH0_APP_AUDIENCE, AUTH0_APP_CLIENT_ID, AUTH0_DOMAIN_NAME } from "./ConstVariable";
import store from "./redux-store/store";

const redirect_uri = process.env.NODE_ENV === "production"?`${window.location.origin}`:`${window.location.origin}`

ReactDOM.render(
    <Auth0Provider
        domain={AUTH0_DOMAIN_NAME}
        clientId={AUTH0_APP_CLIENT_ID}
        redirectUri={redirect_uri}
        audience={AUTH0_APP_AUDIENCE}
        responseType="id_token token"
        scope="read:current_user update:current_user_metadata"
    >
        <MyContextProvider>

            <Provider store={store}>

                <RenderToIndex />
            </Provider>
        </MyContextProvider>

    </Auth0Provider>,
    document.getElementById("root")
);
